export default {"src":"/_next/static/media/x-cart-close-icon.c9250137.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};